import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, Clock, Instagram, Facebook } from 'lucide-react';
const Footer = () => {
  return <footer className="bg-gray-800 text-white" data-id="element-94">
      <div className="container mx-auto px-4 py-12" data-id="element-95">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-96">
          {/* Footer Navigation */}
          <div data-id="element-97">
            <h3 className="text-xl font-semibold mb-4" data-id="element-98">Quick Links</h3>
            <ul className="space-y-2" data-id="element-99">
              <li data-id="element-100">
                <Link to="/" className="hover:text-burgundy-300 transition-colors" data-id="element-101">
                  Home
                </Link>
              </li>
              <li data-id="element-102">
                <Link to="/tips" className="hover:text-burgundy-300 transition-colors" data-id="element-103">
                  Tips
                </Link>
              </li>
              <li data-id="element-104">
                <Link to="/faq" className="hover:text-burgundy-300 transition-colors" data-id="element-105">
                  FAQ
                </Link>
              </li>
              <li data-id="element-106">
                <Link to="/blogs" className="hover:text-burgundy-300 transition-colors" data-id="element-107">
                  Blogs
                </Link>
              </li>
              <li data-id="element-108">
                <Link to="/about" className="hover:text-burgundy-300 transition-colors" data-id="element-109">
                  About Us
                </Link>
              </li>
              <li data-id="element-110">
                <Link to="/contact" className="hover:text-burgundy-300 transition-colors" data-id="element-111">
                  Contact Us
                </Link>
              </li>
              <li data-id="element-112">
                <Link to="/standard-lessons" className="hover:text-burgundy-300 transition-colors" data-id="element-113">
                  Standard Lessons
                </Link>
              </li>
              <li data-id="element-114">
                <Link to="/intensive-lessons" className="hover:text-burgundy-300 transition-colors" data-id="element-115">
                  Intensive Lessons
                </Link>
              </li>
              <li data-id="element-116">
                <Link to="/additional-lessons" className="hover:text-burgundy-300 transition-colors" data-id="element-117">
                  Additional Lessons
                </Link>
              </li>
              <li data-id="element-118">
                <Link to="/total-drive" className="hover:text-burgundy-300 transition-colors" data-id="element-119">
                  Total Drive App
                </Link>
              </li>
            </ul>
          </div>
          {/* Operating Hours */}
          <div data-id="element-120">
            <h3 className="text-xl font-semibold mb-4" data-id="element-121">Operating Hours</h3>
            <ul className="space-y-2" data-id="element-122">
              <li className="flex items-center gap-2" data-id="element-123">
                <Clock size={16} data-id="element-124" />
                <span data-id="element-125">Monday - Thursday: 9:15 AM - 7:00 PM</span>
              </li>
              <li className="flex items-center gap-2" data-id="element-126">
                <Clock size={16} data-id="element-127" />
                <span data-id="element-128">Friday: Closed</span>
              </li>
              <li className="flex items-center gap-2" data-id="element-129">
                <Clock size={16} data-id="element-130" />
                <span data-id="element-131">Saturday - Sunday: 9:15 AM - 7:00 PM</span>
              </li>
            </ul>
          </div>
          {/* Customer Care */}
          <div data-id="element-132">
            <h3 className="text-xl font-semibold mb-4" data-id="element-133">Customer Care</h3>
            <ul className="space-y-2" data-id="element-134">
              <li className="flex items-center gap-2" data-id="element-135">
                <Phone size={16} data-id="element-136" />
                <a href="tel:07481300600" className="hover:text-burgundy-300 transition-colors" data-id="element-137">
                  07481 300 600
                </a>
              </li>
              <li className="flex items-center gap-2" data-id="element-138">
                <Mail size={16} data-id="element-139" />
                <a href="mailto:info@northamptondrivingschool.co.uk" className="hover:text-burgundy-300 transition-colors" data-id="element-140">
                  info@northamptondrivingschool.co.uk
                </a>
              </li>
            </ul>
            <div className="flex gap-4 mt-4" data-id="element-141">
              <a href="#" aria-label="Facebook" className="hover:text-burgundy-300 transition-colors" data-id="element-142">
                <Facebook size={20} data-id="element-143" />
              </a>
              <a href="#" aria-label="Instagram" className="hover:text-burgundy-300 transition-colors" data-id="element-144">
                <Instagram size={20} data-id="element-145" />
              </a>
            </div>
          </div>
        </div>
        <hr className="my-8 border-gray-700" data-id="element-146" />
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-147">
          <div className="text-sm text-gray-400 mb-4 md:mb-0 flex flex-col items-center md:items-start" data-id="element-148">
            <div data-id="element-149">
              <span data-id="element-150">
                <span className="text-burgundy-300" data-id="element-151">N</span>orthampton{' '}
                <span className="text-burgundy-300" data-id="element-152">D</span>riving{' '}
                <span className="text-burgundy-300" data-id="element-153">S</span>chool
              </span>
            </div>
            <div className="mt-2" data-id="element-154">
              &copy; {new Date().getFullYear()} All rights reserved.
            </div>
          </div>
          <div className="flex flex-wrap gap-4 text-sm" data-id="element-155">
            <Link to="/privacy" className="hover:text-burgundy-300 transition-colors" data-id="element-156">
              Privacy & Cookie Policy
            </Link>
            <Link to="/terms" className="hover:text-burgundy-300 transition-colors" data-id="element-157">
              Terms & Conditions
            </Link>
            <Link to="/cancellation" className="hover:text-burgundy-300 transition-colors" data-id="element-158">
              Cancellation Policy
            </Link>
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;